module.exports = __webpack_public_path__ + "static/media/product.abc66021.jpg";